module.exports = __webpack_public_path__ + "static/media/slack.231954d5.png";